import { isIOS, isMobile } from "react-device-detect";

import { common } from "@material-ui/core/colors";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import { defaultTheme } from "react-admin";
import merge from "lodash/merge";

const sfOrange = "#FA9917";
const sfLightOrange = "#FEF2E1";
const sfWhite = "#fdfdfd";
const sfPureWhite = "#ffffff";
const sfMidGray = "#ebebeb";
const sfDarkGray = "#828282";
const sfDarkGray2 = "#C4C4C4";
const sfLightGray = "#fafafa";
const sfLightGray2 = "#F4F4F4";
const sfRed = "#B00020";
const sfLightRed = "#B0002030";
const sfBlue = "#0B1E60";
const sfGreen = "#99CC6C";
const sfBrown = "#8A5642";
const sfDarkOrange = "#ac6f0f";
const sfLightBlue = "#c7e4e5";
const sfBlack = "#111111";
const sfSearchBarBackground = "#EDEDF0";
const sfLayoutBackground = "#f3f3f3";
const sfPotentialBlue = "#0B1E60";
const sfDarkBlue = "#142049";

let raLayoutRoot = {};
if (isMobile && isIOS) {
  raLayoutRoot = {
    position: "relative",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,

    height: "-webkit-fill-available",
    minHeight: "-webkit-fill-available",
    // minHeight: "100%",
    // minHeight: "-webkit-fill-available",
    // maxHeight: "-webkit-fill-available",
  };
} else {
  raLayoutRoot = {
    position: "relative",
    top: 0,
    bottom: 0,

    left: 0,
    right: 0,
    height: "100%",
  };
}

const baseCSS = {
  defaultMarginTop: 10,
  defaultTextFieldHeight: 46,
  red: sfRed,
  orange: sfOrange,
  lightOrange: sfLightOrange,
  darkOrange: sfDarkOrange,
  white: sfWhite,
  pureWhite: sfPureWhite,
  midGray: sfMidGray,
  darkGray: sfDarkGray,
  darkGray2: sfDarkGray2,
  lightRed: sfLightRed,
  lightGray: sfLightGray,
  lightGray2: sfLightGray2,
  searchBarGray: sfSearchBarBackground,
  layoutBackground: sfLayoutBackground,
  blue: sfBlue,
  potentialBlue: sfPotentialBlue,
  darkBlue: sfDarkBlue,
  green: sfGreen,
  brown: sfBrown,
  black: sfBlack,
  layout: {
    main: {
      backgroundColor: sfLayoutBackground,
    },
    leftPanel: {
      backgroundColor: "#f3f3f3",
    },
    rightPanel: {
      backgroundColor: "#f2f2f2",
    },
    walletPanel: { backgroundColor: "#FEF2E1" },
    nonSelected: { backgroundColor: sfMidGray },
  },
  default: {
    normal: { backgroundColor: "#f2f2f2" },
  },
  palette: {
    primary: {
      main: sfOrange,
      contrastText: sfWhite,
    },
    secondary: {
      main: sfDarkGray,
      contrastText: common.white,
    },
    disabled: {
      main: "#828282",
    },

    contrastThreshold: 4,
    tonalOffset: 0.1,
  },

  textPrimary: "#000000",
  textSecondary: "#eeeeee",
  title: {
    fontSize: 20,
    color: sfDarkGray,
  },
  buttonLabelPrimary: {
    fontSize: 24,
    color: sfWhite,
  },
  buttonLabelSecondary: {
    fontSize: 24,
    color: sfWhite,
  },
  generalButtonPrimary: {
    width: 272,
    height: 69,
    backgroundColor: sfOrange,
  },
  generalButtonPotentialPrimary: {
    width: 272,
    height: 69,
    backgroundColor: sfBlue,
    fontSize: 24,
    color: sfWhite,
  },
  buttonLabelPrimaryOutlined: {
    fontSize: 24,
    color: sfOrange,
  },
  buttonLabelPrimaryPotentialOutlined: {
    fontSize: 24,
    color: sfPotentialBlue,
  },
  h7: {
    fontSize: 16,
    fontWeight: "bold",
  },
  typography: {
    fontFamily: ["roboto"].join(","),

    h1: {},
    h2: { fontSize: 32, color: sfDarkGray, fontWeight: 700 },
    h3: { fontSize: 28, color: sfDarkGray, fontWeight: "bold" },
    h4: { fontSize: 24, color: sfDarkGray, fontWeight: 700 },
    h5: { fontSize: 20, color: sfOrange, fontWeight: 700 },
    h6: { fontSize: 20, color: sfDarkGray },

    subtitle1: {
      fontSize: 16,
      color: sfDarkGray,
      fontWeight: 600,
    },
    subtitle2: {
      fontSize: 16,
      color: sfDarkGray,
      fontWeight: 500,
    },
    body1: { color: sfDarkGray },
    body2: { color: sfDarkGray, fontSize: 16 },
    caption: {},
    button: {
      color: sfWhite,
      textTransform: "none",
    },
  },
  scrollbar: {
    width: 4,
  },
  sidebar: {
    width: 200, // The default value is 240
    closedWidth: 1, // The default value is 55
  },
  proceedButton: {
    width: 322,
    height: 57,
  },
  searchBar_searchButton: {
    width: 80,
    height: 40,
  },
  bigIconwithTextContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  bigIconwithTextContainer_text: { fontSize: 32 },
  bigIconwithTextContainer_icon: { width: 112, height: 112 },

  overrides: {
    RaList: {
      root: {
        minHeight: "0vh",
      },
    },
    MuiAvatar: {
      colorDefault: {
        color: sfBlack,
        backgroundColor: sfLightBlue,
      },
    },

    MuiTablePagination: {
      toolbar: {
        height: 50,
      },
    },
    MuiTable: {
      root: {
        backgroundColor: sfLightGray,
      },
    },
    MuiTableRow: {
      root: {
        "&$selected": {
          backgroundColor: sfLightOrange,
        },
      },
      hover: {
        "&:hover": {
          backgroundColor: "#FEF2E1 !important",
        },
      },
    },
    MuiTypography: {
      colorTextPrimary: { color: "#ffffff" },
      colorTextSecondary: { color: "#000000" },
    },
    MuiButton: {
      root: {
        borderRadius: 12,
      },
      containedPrimary: {
        backgroundColor: sfOrange,
        color: sfWhite,
        borderRadius: 12,
      },
      containedSecondary: {
        backgroundColor: sfDarkGray,
        color: sfWhite,
        borderRadius: 12,
      },
    },
    RaLayout: {
      root: raLayoutRoot,
      content: {
        position: "relative",
        top: 0,
        padding: "0px !important",
        // paddingTop: 10,
        bottom: 0,
      },
      contentWithSidebar: {
        position: "relative",
        top: 0,
        left: 0,
        right: 0,
        padding: 0,

        boxSizing: "border-box",
        // paddingTop: 10,
        bottom: 0,
        height: "100%",
        maxHeight: "100%",
        minHeight: "100%",
      },
    },
    RaSidebar: {
      root: {
        paddingTop: 40,
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: 0,
      },
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: sfPureWhite,
        // height: 46,
        borderRadius: 8,
        border: "1px solid #EBEBEB",
      },
    },
    RaAppBar: {
      toolbar: {
        backgroundColor: sfOrange,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "space-between",
        "& button": {
          "& :nth-child(9)": {
            display: "none",
          },
        },
      },
    },

    MuiToggleButton: {
      root: {
        color: sfOrange,
        borderColor: sfOrange,
        borderRadius: 8,
        height: 46,
        borderSize: 3,
        "&$selected": { backgroundColor: sfOrange, color: sfWhite },
      },
    },
  },
};

const theme = createMuiTheme(merge({}, defaultTheme, baseCSS));

export default theme;
